import React, { useContext } from "react";
import tick from "../../../../assets/svgs/tick.svg";
import { AuthContext } from "../../../../context/AuthContext";
type TableRow = {
  task: string;
};

type TableProps = {
  rows: TableRow[]; // Array of table rows
  bgColor?: string; // Background color (optional)
  headerColor?: string; // Header color (optional)
  className?: string; // Additional custom classes (optional)
  text1: string;
};
const Task: React.FC<TableProps> = ({
  rows,
  bgColor, // Default background color
  headerColor, // Default header color
  className = "",
  text1,
}) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div
      className={`${
        theme === "dark" ? `${bgColor}` : "bg-[#141414]"
      } text-white ${className} transition-all duration-500`}
    >
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-20">
        <h3 className="font-montserrat mb-4">The Challenge</h3>
        <p
          className="font-montserrat sm:text-lg mb-9"
          dangerouslySetInnerHTML={{ __html: text1 }}
        ></p>
        <h2 className="text-4xl font-montserrat font-bold mb-6">
          Tasks we got in this project
        </h2>
        <div className="overflow-x-auto">
          <div className={`${
                theme === "dark" ? "bg-white" : "card-gradient"
              } transition-all duration-500 p-[1px]`}>
            <table
              className={`w-full  ${
                theme === "dark" ? `${bgColor}` : "bg-[#141414]"
              } transition-all duration-500`}
            >
              {/* Table Header */}
              <thead className="">
                <tr>
                  <th
                    className={`${
                      theme === "dark" ? `${headerColor}` : "bg-[#333333]"
                    } transition-all duration-500 py-3 px-4 text-center  text-white font-gtAmerica text-2xl font-normal border-r`}
                  >
                    Task List
                  </th>
                  <th
                    className={`${
                      theme === "dark" ? `${headerColor}` : "bg-[#333333]"
                    } transition-all duration-500 py-3 px-4 text-center  text-white text-2xl font-gtAmerica font-normal`}
                  >
                    Status Done
                  </th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index} className="border-t border-gray-300">
                    <td
                      className="py-3 px-4 border-r border-gray-300 text-center font-gtAmerica text-2xl
                  "
                    >
                      {row.task}
                    </td>
                    <td className="py-3 px-4 text-center flex justify-center">
                      <img src={tick} className="" alt=""/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Task;
